<!--
 * @Descripttion: 预览
 * @Author: zenghua.wang
 * @Date: 2021-04-19 18:00:24
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-04 11:08:56
-->
<template>
  <div
    class="widget-canvas"
    ref="canvas"
    :style="styleCanvas"
  >
    <vue-sketch-rule
      :lang="lang"
      :thick="thick"
      :scale="scale"
      :width="width - thick"
      :height="height - thick"
      :startX="startX"
      :startY="startY"
      :shadow="shadow"
      :horLineArr="lines.h"
      :verLineArr="lines.v"
      :cornerActive="false"
      @handleLine="onSketchLine"
    />

    <div
      ref="canvasSketch"
      class="widget-canvas-sketch"
      @wheel="onSketchWheel"
      @scroll="onSketchScroll"
    >
      <div
        ref="sketchContainer"
        class="sketch-container"
      >
        <div
          ref="sketchScreen"
          class="sketch-screen"
          :style="styleScreen"
        >
          <div
            class="sketch-screen-content"
            :style="styleContent"
          >
            <div
              class="sketch-draggable"
              :style="styleBackground"
            >
              <div
                v-for="(widget, index) in data.list"
                :key="index"
                :style="styleWidget(widget)"
              >
                <component
                  :is="`drag-${widget.type}`"
                  :id="widget.prop"
                  :apiId="widget.apiId"
                  :width="widget.width"
                  :height="widget.height"
                  :option="widget.option"
                  :animation="true"
                  :disabled="false"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSketchRule from 'vue-sketch-ruler'
import { setPx, fixChromeZoom } from '@/dragComponents/utils'
export default {
  name: 'widget-preview',
  components: {
    vueSketchRule
  },
  props: ['data'],
  data() {
    return {
      // sketch
      lang: 'zh-CN',
      width: '100%',
      height: '100%',
      thick: 20,
      // 初始化标尺的缩放
      scale: 0.95,
      // x轴标尺开始的坐标数值
      startX: 0,
      startY: 0,
      // 显示标尺
      isShowRuler: true,
      // 显示参考线
      isShowReferLine: false,
      // 初始化水平标尺上的参考线
      lines: {
        h: [],
        v: []
      },
      // 阴影大小
      shadow: { x: 0, y: 0 },
      loading: false,
      styleContent: {},
      wscale: 1
    }
  },
  computed: {
    styleCanvas() {
      return {
        width: setPx(this.width),
        height: setPx(this.height)
      }
    },
    styleScreen() {
      return {
        width: setPx(this.width),
        transform: `scale(${this.scale})`
      }
    },
    styleBackground() {
      const scale = this.wscale
      const val = scale / 100 + 0.001
      let style = `width:${setPx(this.data.screenWidth)};
      height:${setPx(this.data.screenHeight)};
      background-image:url('${this.data.backgroundImage}');
      background-position:center center;
      background-size:100% 100%;
      background-color:${this.data.backgroundColor};
      transform: scale(${val})`
      return style
    },
    styleWidget() {
      return widget => {
        return {
          position: 'absolute',
          left: setPx(widget.left),
          top: setPx(widget.top),
          zIndex: widget.index
        }
      }
    }
  },
  methods: {
    onSketchLine(lines) {
      this.lines = {
        h: [],
        v: []
      }
    },
    onSketchScroll() {
      const sketchRect = this.$refs.canvasSketch.getBoundingClientRect()
      const sketchScreenRect = this.$refs.sketchScreen.getBoundingClientRect()
      // 标尺开始的刻度
      const startX = (sketchRect.left + this.thick - sketchScreenRect.left) / this.scale
      const startY = (sketchRect.top + this.thick - sketchScreenRect.top) / this.scale
      this.startX = startX >> 0
      this.startY = startY >> 0
    },
    // 控制缩放值
    onSketchWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault()
        const nextScale = parseFloat(Math.max(0.2, this.scale - e.deltaY / 500).toFixed(2))
        this.scale = nextScale
      }
      this.$nextTick(() => {
        this.onSketchScroll()
      })
    },
    initSize() {
      if (!this.$refs.canvas) return
      let canvasRect = this.$refs.canvas.getBoundingClientRect()
      let dom = this.$refs.sketchContainer.getBoundingClientRect()
      this.width = canvasRect.width
      this.height = window.innerHeight - 100 // canvasRect.height || document.documentElement.clientHeight || document.body.clientHeight
      this.$refs.canvasSketch.scrollLeft = dom.width / 2 - this.thick
      this.$refs.canvasSketch.scrollTop = dom.height / 2 - this.thick
      this.shadow = { x: 0, y: 0, width: this.width, height: this.height }
    },
    setResize() {
      window.addEventListener('resize', () => {
        let width = this.width
        let height = this.height
        this.initSize()
        let rate = Math.min(this.width / width, this.height / height)
        this.scale = rate > 1 ? rate * 0.5 : rate
      })
    },
    // 计算比例
    setScale() {
      this.wscale = (this.width / this.data.screenWidth) * 100
      this.styleContent = {
        width: setPx((this.wscale * this.data.screenWidth) / 100),
        height: setPx((this.wscale * this.data.screenHeight) / 100)
      }
    }
  },
  created() {
    this.setResize()
  },
  mounted() {
    this.$nextTick(() => {
      fixChromeZoom(this.$refs.canvas)
      this.initSize()
      this.setScale()
    })
  }
}
</script>
